import { packGranel } from "./granelPacker";
import { packGranel2 } from "./granel2Packer";
import { packPallet } from "./palletPacker";

/**
 * @param {string|null|undefined} shipmentTypeCode
 * @param {object} input - dims + quantity + container dims
 * @returns {import("./types").PackPlan}
 */
export function pack(shipmentTypeCode, input) {
  const code = String(shipmentTypeCode || "").toUpperCase().trim();

  if (code === "PALLET") {
    return packPallet(input);
  }

  // Legacy stepped packer (can lift the filler-line floor end off y=0).
  if (code === "GRANEL") {
    return packGranel(input);
  }

  // GRANEL2 and default (FCL / empty / etc.): line always pivots to container floor.
  return packGranel2(input);
}

export { packGranel, packGranel2, packPallet };
